<template>
  <div class="pm-card pm-empty">
    <h2 class="pm-empty__title">
      Пока нет сохранённых карт
    </h2>
    <p class="pm-empty__subtitle">
      <template v-if="canUseBilling">
        Добавьте карту, чтобы пополнять баланс в один клик<br>
        и включить автосписание платы за тариф
      </template>
      <template v-else>
        Карты не привязаны: пополнение в один клик и автосписание платы за тариф не подключены
      </template>
    </p>
    <img
      class="pm-empty__image"
      src="/img/empty-card-list.png"
      alt=""
    >
    <v-btn
      v-if="canUseBilling"
      class="pm-empty__add-btn"
      depressed
      x-large
      :loading="busy"
      :disabled="busy"
      @click="$emit('add')"
    >
      <v-icon left>
        mdi-plus
      </v-icon>
      Добавить карту
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'PaymentMethodsEmpty',
    props: {
      busy: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="less" scoped>
.pm-card {
  background-color: #fff;
  border: 1px solid #c4cdd9;
  border-radius: 8px;
  padding: 24px;
}

.pm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 64px 24px;

  .media-xs({
    padding: 32px 16px;
  });

  &__title {
    font-size: 28px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 12px;

    .media-xs({
      font-size: 20px;
    });
  }

  &__subtitle {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.54);
    margin-bottom: 24px;
    line-height: 1.5;

    .media-xs({
      font-size: 14px;
    });
  }

  &__image {
    width: 100%;
    max-width: 240px;
    height: auto;
    margin-bottom: 32px;

    .media-xs({
      max-width: 160px;
      margin-bottom: 24px;
    });
  }

  &__add-btn.v-btn {
    background-color: #4caf50 !important;
    color: #fff !important;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: normal;

    .media-xs({
      width: 100%;
    });
  }
}
</style>
